<template>
    <div>
        <div class="mb-6 -mt-4">
            <h1>Investment Objectives</h1>
        </div>

        <div class="mb-6">
            <h2>
                Please indicate the type (s) of product that you wish to transact. Your trading intentions should
                correspond with your experience.
            </h2>
        </div>

        <ValidationObserver ref="investmentObjectivesObserver">
            <div class="mb-6">
                <CheckboxComponent
                    alternateStyle
                    id="foreign_exchange"
                    name="foreign_exchange"
                    label="Spot &amp; foreign exchange"
                    v-model="investmentObjectives.foreign_exchange"
                    @change="updateInvestmentObjectives"
                    rules="optional"
                />
            </div>

            <div class="mb-6">
                <CheckboxComponent
                    alternateStyle
                    id="shares_bonds_funds"
                    name="shares_bonds_funds"
                    label="Shares, bonds &amp; funds"
                    v-model="investmentObjectives.shares_bonds_funds"
                    @change="updateInvestmentObjectives"
                    rules="optional"
                />
            </div>

            <div class="mb-6">
                <CheckboxComponent
                    alternateStyle
                    id="stock_index_options"
                    name="stock_index_options"
                    label="Stock options &amp; stock index options"
                    v-model="investmentObjectives.stock_index_options"
                    @change="updateInvestmentObjectives"
                    rules="optional"
                />
            </div>

            <div class="mb-6">
                <CheckboxComponent
                    alternateStyle
                    id="financial_futures_options"
                    name="financial_futures_options"
                    label="Financial futures &amp; options"
                    v-model="investmentObjectives.financial_futures_options"
                    @change="updateInvestmentObjectives"
                    rules="optional"
                />
            </div>

            <div class="mb-6">
                <CheckboxComponent
                    alternateStyle
                    id="commodity_futures_options"
                    name="commodity_futures_options"
                    label="Commodity futures &amp; options"
                    v-model="investmentObjectives.commodity_futures_options"
                    @change="updateInvestmentObjectives"
                    rules="optional"
                />
            </div>

            <div class="mb-6">
                If you have ticked any of the options products, we understand that you wish to trade in derivative products which involve a high level of risk and your investment horizon is short term.
            </div>

            <div class="mb-6">
                <InputComponent
                    label="If the foregoing does not accurately represent your investment objectives, please specify below what your investment objectives are and what your investment horizon is."
                    placeholder="Please specify"
                    name="investmentObjectives_details"
                    v-model="investmentObjectives.investment_objectives_details"
                    @change="updateInvestmentObjectives"
                    rules="optional"
                />
            </div>

            <div class="mb-6">
                <ConfirmationComponent
                    id="confirm_proprietary_transactions"
                    name="confirm_proprietary_transactions"
                    label="Confirm"
                    text="Please confirm that your transactions and positions will be proprietary in nature"
                    hint="This is to confirm that you will only be trading on behalf of yourself."
                    v-model="investmentObjectives.confirm_proprietary_transactions"
                    @change="updateInvestmentObjectives"
                />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver } from "vee-validate";
import InputComponent from "@components/inputs/InputComponent";
import DropdownComponent from "@components/inputs/DropdownComponent";
import YesNoSliderComponent from "@components/inputs/YesNoSliderComponent";
import ScaleSliderComponent from "@components/inputs/ScaleSliderComponent";
import stepperValidationService from "@services/stepperValidationService";

export default {
    name: "InvestmentObjectivesFormComponent",
    components: {
        ValidationObserver,
        InputComponent,
        DropdownComponent,
        YesNoSliderComponent,
        ScaleSliderComponent,
    },
    props: {
        step: { default: "" },
    },
    data() {
        return {
            investmentObjectives: {},
            isFormValidated: false,
        };
    },
    computed: {
        ...mapGetters(["investmentObjectivesState"])
    },
    methods: {
        ...mapActions(["doGetInvestmentObjectives", "doUpdateInvestmentObjectives"]),
        updateInvestmentObjectives() {
            this.doUpdateInvestmentObjectives(this.investmentObjectives);
        },
        doValidateForm() {
            stepperValidationService.checkStepperStepStatus(
                this.step,
                this.investmentObjectives,
                this.$refs.investmentObjectivesObserver,
                false,
                true
            );
        },
    },
    mounted() {
        this.$root.$on("submittingApplication", () => this.doValidateForm());
       this.$root.$on("stepChanged", (step) => {
            if ((this.step < step) && !this.isFormValidated){
                this.doValidateForm();
                this.isFormValidated = true;
            }else if(this.step == step){
                this.isFormValidated = false
            }
        });

        this.doGetInvestmentObjectives().then((response) => this.investmentObjectives = response);

        this.$gtm.trackView('Investment Objectives', 'currentPath');
    },
    watch: {
        investmentObjectives() {
            stepperValidationService.checkStepperStepStatus(
                this.step,
                this.investmentObjectives,
                this.$refs.investmentObjectivesObserver
            );
        },
    },
};
</script>
